var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{ref:_vm.fref,attrs:{"icon":_vm.icon,"size":_vm.size,"plain":_vm.fplain,"round":_vm.round,"circle":_vm.circle,"type":_vm.typeStyle,"autofocus":false,"loading":_vm.fLoading,"disabled":_vm.btn_disabled},on:{"click":function($event){return _vm.handleClick(_vm.clickEvent)}}},[_vm._v(" "+_vm._s(_vm.fContent)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }